import { forwardRef } from "react";

import Icon from "@/components/Icon";
import RawRemindIcon from "./RawRemindIcon.svg.jsx";

const RemindIcon = forwardRef((props, ref) => {
  return <Icon ref={ref} SvgComponent={RawRemindIcon} {...props} />;
});

export default RemindIcon;
